import { render, staticRenderFns } from "./Storytelling_import_Presentazione_eng.vue?vue&type=template&id=2ce3a0d8&scoped=true&"
import script from "./Storytelling_import_Presentazione_eng.vue?vue&type=script&setup=true&lang=js&"
export * from "./Storytelling_import_Presentazione_eng.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Storytelling_import_Presentazione_eng.vue?vue&type=style&index=0&id=2ce3a0d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce3a0d8",
  null
  
)

export default component.exports